import { AuthGate } from "./AuthGate";
import { ClosedBanner } from "./ClosedBanner";
import { Composer } from "./Composer";
import { CollapsibleComposerSkeleton } from "./Composer/CollapsibleComposerSkeleton";
import { Feed } from "./Feed";
import { Provider } from "./Provider";
import { Section } from "./Section";

export const Comments = {
  Provider,
  Section,
  ClosedBanner,
  AuthGate,
  Feed,
  Composer,
  CollapsibleComposerSkeleton,
};
